export const paramsKind = ['cs', 's2s'] as const
export type ParamsKind = (typeof paramsKind)[number]
